import * as Sentry from '@sentry/react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import toaster from 'react-hot-toast';
import { retriggerInitialization } from 'api/admin/devices/devices';

type ReinitializeWashboardDeviceVariables = {
  deviceId: number;
  deviceName: string;
  skipToast?: boolean;
};

export const useReinitializeWashboardDevice = () => {
  const queryClient = useQueryClient();

  return useMutation<unknown, AxiosError<{ error: string }>, ReinitializeWashboardDeviceVariables>({
    mutationFn: async ({ deviceId }: ReinitializeWashboardDeviceVariables) => {
      return retriggerInitialization(deviceId);
    },
    onSuccess: async (_, variables) => {
      if (!variables.skipToast) {
        toaster('Device reinitialized successfully', {
          icon: '✅',
        });
      }
      queryClient.invalidateQueries({ queryKey: ['washboardDevices'] });
    },
    onError: (error, variables) => {
      Sentry.captureException(error);
      if (!variables.skipToast) {
        const errorMessage = error?.response?.data?.error ?? 'Failed to reinitialize device';
        const message = `${errorMessage} (${variables?.deviceName})`;
        toaster(message, {
          icon: '❌',
        });
      }
    },
  });
};
